import * as React from "react";

import { cn } from "@/src/js/lib/utils";
import { SECTION_TITLE_CLASS } from "./styles";

// The title of a fieldset, in the chart color of the period it is about. Preflight is off, so the
// browser's default fieldset and legend spacing and border are reset where they are used
export function SectionLegend({ swatchClass, title }: { swatchClass: string; title: string }) {
  return (
    <legend className={cn("tw:mb-2 tw:flex tw:items-center tw:gap-2 tw:p-0", SECTION_TITLE_CLASS)}>
      <span className={cn("tw:size-3 tw:shrink-0 tw:rounded-sm", swatchClass)} aria-hidden="true" />
      {title}
    </legend>
  );
}
